import type { ApiQuestion } from '../../../../internalTypes';
import type { McqOption } from '../../../../types/mcq';
import { mapAnswerLogic } from '../shared/mapAnswerLogic';
import { extractOtherOptionConfig } from './extractOtherOptionConfig';

export function buildMcqOptions(question: ApiQuestion, language?: string): McqOption[] {
  return (question.answerDetails ?? [])
    .filter(a => !a.hidden && !a.additional?.isHintText)
    .map((a, i) => {
      const answerLogic = mapAnswerLogic(a.controlConfig?.displayLogic);
      const optionLabel =
        (language && a.translations?.[language]?.answerText) || a.answerText || '';
      const otherOption = extractOtherOptionConfig(a, optionLabel);

      return {
        id: a.id ?? String(i),
        optionLabel: otherOption?.label ?? optionLabel,
        ...(answerLogic ? { answerLogic } : {}),
        ...(otherOption ? { otherOption } : {}),
      };
    });
}
